/**
 * Format l’URL de la vidéo en fonction du provider.
 * @param {object} param0
 * @param {object} param0.url
 * @return {string}
 */
export default function videoFormatUrl({ url }) {
  if (/^https:\/\/www\.facebook\.com\/plugins\/video\.php/.test(url)) {
    const widthRegexp = /width=\d+/;
    const heightRegexp = /height=\d+/;

    if (widthRegexp.test(url)) {
      url = url.replace(widthRegexp, "width=800");
    } else {
      url += "&width=800";
    }

    if (heightRegexp.test(url)) {
      url = url.replace(heightRegexp, "height=450");
    } else {
      url += "&height=450";
    }

    return `${url}&autoplay=false`;
  } else {
    if (/\?/.test(url)) {
      return `${url}&autoplay=0&controls=2`;
    }

    return `${url}?autoplay=0&controls=2`;
  }
}
